<template>
  <VContainer
    class="terms-and-conditions-page-contaner pt-11"
    fluid
  >
    <SBackButton class="mb-6" />
    <SArticle
      :title="article.title"
      :subTitle="article.subTitle"
      :content="article.content"
    />
  </VContainer>
</template>

<script lang="ts">
export default {
  name: 'STermsAndConditions',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import SArticle from '@slg/web-customer-shared/src/components/common/SArticle';
import SBackButton from '@slg/web-customer-shared/src/components/common/SBackButton';
import { useCmsLocaleReload } from '../../composables';

const pageData = ref<Record<string, any> | null>(null);

const article = computed(() => pageData.value?.article || {});

async function loadCmsData() {
  try {
    pageData.value = await StrapiService.getTermsAndConditionsPage();
  } catch (e) {
    // to-do rethink about catch
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style lang="scss">
.terms-and-conditions-page-contaner {
  margin: 0 auto;
  min-height: 400px;
}
</style>
